import React from 'react';
import { Typography, Tooltip } from 'seagull';
import styles from "./CustomXAxisTick.module.scss";
const chevronWidth = 4;

// eslint-disable-next-line @typescript-eslint/no-explicit-any

export default function CustomXAxisTick(props) {
  const {
    index,
    visibleTicksCount,
    x,
    y,
    payload,
    width,
    tickWidth = 90,
    tickHeight = 60,
    addChevron,
    testid,
    getText,
    getTooltip
  } = props;
  const step = width / (visibleTicksCount * 2);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("foreignObject", {
    x: x - tickWidth / 2,
    y: y,
    width: tickWidth,
    height: tickHeight
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: 'http://www.w3.org/1999/xhtml',
    className: styles.tick
  }, /*#__PURE__*/React.createElement(Tooltip, {
    title: getTooltip ? getTooltip(payload.value) : '',
    placement: "top",
    disableArrow: true
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph3",
    skin: "secondary",
    "data-testid": testid && "".concat(testid, "-").concat(payload.value)
  }, getText ? getText(props) : payload.value)))), addChevron && index < visibleTicksCount - 1 && /*#__PURE__*/React.createElement("path", {
    transform: "translate(".concat(x + step - chevronWidth / 2, ",").concat(y - 3 + tickHeight / 2, ")"),
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.63 7.43c0-.14.04-.27.13-.37L3.3 4 .85.93a.57.57 0 0 1 .08-.8c.25-.2.6-.16.8.08L4.5 3.64c.17.21.17.52 0 .73L1.64 7.79a.57.57 0 0 1-.8.08.57.57 0 0 1-.21-.44Z",
    fill: "#D4D4E0"
  }));
}